// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modle_Modal__VfgKI"};